module.exports = __webpack_public_path__ + "img/scenario-final.270c0d7.svg";